<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue: keepOrder">
      <h5 class="transaction-date mt-4 mb-3 text-primary">{{ day.key }}</h5>
      <div class="mb-0 mb-lg-5">
        <div class="card my-3 py-2 px-4 border-0" *ngFor="let transaction of day.value">
          <div class="row">
            <div class="col-8 text-start">
              <div class="fw-bold text-black transaction-text">
                {{ transaction.TransactionDescription }}
              </div>

              <div class="transaction-subtext">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
              </div>
            </div>
            <div class="col-4 text-end pt-2">
              <div
                class="fw-bold transaction-text text-capitalize"
                [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
              >
                {{ transaction.Amount >= 0 ? '+' : ''
                }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty">
      <div>
        <span class="icon material-icons material-history-icon text-grey no-activity-image text-center w-100 mt-5 mb-3"
          >history</span
        >
        <h5 class="text-primary text-center fw-bold text-uppercase font-size-16">
          {{ 'no.activity.placeholder.list.title' | translate }}
        </h5>
        <p class="text-info text-center font-size-12">{{ 'account.activity.placeholder.list.description' | translate }}</p>
      </div>
    </ng-container>
    <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.ecash">
      <div>
        <img class="no-ecash-image d-flex mx-auto" src="assets/images/icons/no-transactions.svg" />
        <h5 class="text-primary text-center fw-bold text-uppercase font-size-16">no.transactions.placeholder.list.title</h5>
        <p class="text-info text-center font-size-12">{{ 'account.activity.placeholder.list.description' | translate }}</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
